import { render, staticRenderFns } from "./IconStart.vue?vue&type=template&id=9873b0b4&scoped=true&"
import script from "./IconStart.vue?vue&type=script&lang=js&"
export * from "./IconStart.vue?vue&type=script&lang=js&"
import style0 from "./IconStart.vue?vue&type=style&index=0&id=9873b0b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9873b0b4",
  null
  
)

export default component.exports